module.exports = __webpack_public_path__ + "static/media/dash-green.5c43d630.svg";